import React, {useCallback, useEffect, useState} from 'react';
import {View, FlatList, StyleSheet, TouchableOpacity} from 'react-native';
import {Text, Searchbar, Divider, ActivityIndicator} from 'react-native-paper';
import {useNavigation} from '@react-navigation/native';
import {workerApi} from '../../services/api/workerApi';
import GradientHeader from '../../components/common/GradientHeader';
import {colors, spacing} from '../../theme';

const SalesStaffSelectorScreen = () => {
  const navigation = useNavigation();
  const [workers, setWorkers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await workerApi.list({page: 0, size: 100});
        const list = res.data.data.content || [];
        setWorkers(list);
        setFiltered(list);
      } catch (e) {
        // ignore
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSearch = useCallback(query => {
    setSearch(query);
    if (query.trim()) {
      setFiltered(workers.filter(w =>
        w.fullName.toLowerCase().includes(query.toLowerCase())
      ));
    } else {
      setFiltered(workers);
    }
  }, [workers]);

  const handleSelect = useCallback((worker) => {
    navigation.navigate({
      name: 'OrderLineDetail',
      params: {
        salesStaffId: worker.id,
        salesStaffName: worker.fullName,
      },
      merge: true,
      pop: true,
    });
  }, [navigation]);

  return (
    <View style={styles.container}>
      <GradientHeader title="Select Sales Staff" onBack={() => navigation.goBack()} />

      <Searchbar
        placeholder="Search workers..."
        value={search}
        onChangeText={handleSearch}
        style={styles.searchbar}
      />

      {loading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          data={filtered}
          keyExtractor={item => String(item.id)}
          ItemSeparatorComponent={Divider}
          renderItem={({item}) => (
            <TouchableOpacity onPress={() => handleSelect(item)} activeOpacity={0.7}>
              <View style={styles.row}>
                <Text variant="bodyLarge" style={styles.name}>{item.fullName}</Text>
                {item.phone && <Text variant="bodySmall" style={styles.phone}>{item.phone}</Text>}
              </View>
            </TouchableOpacity>
          )}
          ListEmptyComponent={
            <View style={styles.emptyContainer}>
              <Text style={styles.emptyText}>No workers found</Text>
            </View>
          }
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {flex: 1, backgroundColor: colors.background},
  searchbar: {margin: spacing.sm, backgroundColor: colors.surface, elevation: 0},
  loadingContainer: {flex: 1, justifyContent: 'center', alignItems: 'center'},
  row: {
    paddingHorizontal: spacing.md, paddingVertical: spacing.md,
    backgroundColor: colors.surface,
  },
  name: {color: colors.text, fontWeight: '500'},
  phone: {color: colors.textSecondary, marginTop: 2},
  emptyContainer: {flex: 1, justifyContent: 'center', alignItems: 'center', paddingTop: spacing.xxl * 2},
  emptyText: {color: colors.textSecondary},
});

export default SalesStaffSelectorScreen;
